const socialLinks = [
  {
    name: "Instagram",
    url: "https://www.instagram.com/elyarandrianaivo?igsh=MXg3cmN4NjA1a2w5eg==",
    icon: "instagram",
  },
  {
    name: "Linktree",
    url: "https://linktr.ee/elyarandrianaivo",
    icon: "linktree",
  },
  {
    name: "Vimeo",
    url: "https://vimeo.com/showcase/10526024",
    icon: "vimeo",
    size: 40,
  },
  {
    name: "Imdb",
    url: "https://www.imdb.com/name/nm11821078/",
    icon: "imdb",
    size: 40,
  },
];

export default socialLinks;
